import { useNavigate } from 'react-router-dom';
import { useAuthStore } from 'src/store/auth';

export interface ResetPasswordCredentials {
  password: string;
  confirmPassword: string;
}

export const useResetPassword = () => {
  const { resetPassword: resetPasswordAction, clear, isLoading, error, success } = useAuthStore();
  const navigate = useNavigate();

  const resetPassword = async ({ password }: Omit<ResetPasswordCredentials, 'confirmPassword'> & { confirmPassword?: string }) => {
    const token = new URLSearchParams(window.location.search).get('token');
    const rpt = new URLSearchParams(window.location.search).get('rpt');
    const rptNumber = rpt ? parseInt(rpt, 10) : 0;

    if (!token) {
      console.error('Reset token not found in URL');
      return;
    }

    await resetPasswordAction({ token, password, rpt: rptNumber });

    if (localStorage.getItem('token')) {
      // The API might not log the user in upon password reset. If not, remove this redirect or adjust accordingly.
      setTimeout(() => navigate('/login', { replace: true }), 2000);
    } else {
      // Even if not logged in, we redirect after success message
      if (success) {
        setTimeout(() => navigate('/login', { replace: true }), 2000);
      }
    }
  };

  return { clear, resetPassword, isLoading, error, success };
};
